import { INode } from '../chatmessage/types';
import values from 'lodash/values';

import { ChatBaseDataAction } from './types';

const defaultState: INode[] = [];
export default function chatBaseDataReducer(state = defaultState, action: any) {
  switch (action.type) {
    case ChatBaseDataAction.INIT:
      const newState: INode[] = values(action.payload.chatbotData);
      return newState;
    default:
      return state;
  }
}
